import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import userDashboardBackground from "./assets/userdashboardbg.png";

function UserDashboard() {
  const [firstName, setFirstName] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login");
        return;
      }

      if (!user.emailVerified) {
        navigate("/verify-email");
        return;
      }

      try {
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const data = userDoc.data();
          const name = data.firstName;
          setFirstName(name && name.trim().length > 0 ? name : "User");
        } else {
          setFirstName("User");
        }
      } catch (err) {
        console.error("❌ Failed to fetch user info:", err);
        setFirstName("User");
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const buttons = [
    { label: "Wallet", route: "/wallet" },
    { label: "Create Submission", route: "/submit" },
    { label: "Submission History", route: "/orders" },
    { label: "Profile", route: "/profile" },
  ];

  return (
    <div className="relative min-h-screen font-[Montserrat] text-white overflow-hidden">
      {/* Background */}
      <img
        src={userDashboardBackground}
        alt="Dashboard background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />
      <div className="absolute inset-0 bg-black bg-opacity-60 z-0" />

      {/* Foreground */}
      <div className="relative z-10 min-h-screen">
        <DashboardLayout>
          {/* Greeting */}
          <div className="flex flex-col items-center px-8 mt-[20px]">
            <h2 className="text-3xl font-bold text-center mb-4">
              Hello, {loading ? "..." : firstName}!
            </h2>
          </div>

          {/* Desktop: Embedded Video */}
          <div className="hidden sm:flex justify-center px-8 mt-4">
            <div className="rounded-xl overflow-hidden w-[628px] aspect-video">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/fc9B8GcUP-o"
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Mobile: 4-Button Grid */}
          <div className="sm:hidden px-6 pt-6 pb-12 flex justify-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-4xl">
              {buttons.map((btn, index) => (
                <button
                  key={index}
                  onClick={() => navigate(btn.route)}
                  className="bg-[#1976d2] text-white rounded-2xl flex items-center justify-center text-lg font-bold h-24 shadow-md transition-transform hover:scale-105"
                >
                  {btn.label}
                </button>
              ))}
            </div>
          </div>
        </DashboardLayout>
      </div>
    </div>
  );
}

export default UserDashboard;
